import type { EmailAddress } from "../../services/graphMailService";

export type ZeilenPerson = {
    /** Für den Avatar. */
    name: string;
    email: string;
    /** Was in der Zeile steht. */
    text: string;
    /** Alle Empfänger mit Adresse — als Tooltip. */
    titel?: string;
};

/**
 * Wen eine Zeile der Mailliste nennt.
 *
 * T-193 (Michael Kratzenberg, 05.10.2026): „Ansicht gesendete Objekte — man
 * sieht nicht den Empfänger der Mail, sondern nur sich selber als Absender."
 * In „Gesendet" und „Entwürfe" ist man selbst der Absender jeder Zeile; dort
 * stehen wie in Outlook die Empfänger („An: …"), sonst der Absender. Ohne
 * An-Empfänger zählen die in Cc.
 */
export function zeilenPerson(
    email: { senderName: string; senderEmail: string; to?: EmailAddress[] | null; cc?: EmailAddress[] | null },
    empfaengerZeigen: boolean,
): ZeilenPerson {
    const absender = { name: email.senderName, email: email.senderEmail, text: email.senderName };
    if (!empfaengerZeigen) return absender;
    const empfaenger = (email.to?.length ? email.to : email.cc ?? []).filter((r) => r?.address || r?.name);
    if (!empfaenger.length) return { ...absender, text: "An: (kein Empfänger)" };
    const name = (r: EmailAddress) => r.name?.trim() || r.address;
    return {
        name: name(empfaenger[0]),
        email: empfaenger[0].address,
        text: `An: ${empfaenger.map(name).join("; ")}`,
        titel: empfaenger.map((r) => (r.name?.trim() ? `${r.name.trim()} <${r.address}>` : r.address)).join("; "),
    };
}
